import React from 'react'
import {FormattedNumber} from 'react-intl'

const Price = ({amount, currency, perUnit}) => {
  if(amount ==  null) { return null }
  return <div><FormattedNumber 
            value={amount} 
            style="currency" 
            currency={currency} 
            maximumFractionDigits={0}
            minimumFractionDigits={0}
          />
          {perUnit}
         </div>
}
export default Price 



/** WEBPACK FOOTER **
 ** ./app/components/Price.jsx
 **/